/* eslint-disable max-len */
export const REQUIRED_FIELD = 'This field is required';
export const REQUIRED_FIELD_FOR_SO = 'This field is required for SO generation';
export const MUST_BE_INTEGER = 'Must be an integer';
export const MUST_BE_NUMBER = 'Must be a number';
export const MUST_BE_STRING_GUID = 'Must be a string GUID';
export const DATE_IN_PAST = 'Date can\'t be in the past';
export const END_DATE_BEFORE_START_DATE = 'End date can\'t be before Start date';
export const START_DATE_AFTER_END_DATE = 'Start date can\'t be after End date';
export const INVOICE_DATE_BEFORE_START_DATE = 'Invoice date can\'t be before Start date';
export const DATE_BEFORE_TOMORROW = 'Effective date can\'t be earlier than tomorrow';
export const INVALID_GUID = 'Invalid GUID';
export const FILE_CONTENT_CHANGED = 'Please try to upload the file again. The content of the file might have changed.';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong';
export const FILE_TOO_LARGE_ERROR_MESSAGE = 'The file exceeds the maximum file upload size 30 MB';

export const MIN_STRING_LENGTH_YUP_TEMPLATE = 'Must be minimum ${min} characters';
export const MAX_STRING_LENGTH_YUP_TEMPLATE = 'Must be maximum ${max} characters';

export const DATE_AFTER_DNR_DATE = 'Can\'t be after "DNR Date"';
export const DATE_AFTER_CONTRACT_END = 'Can\'t be after "Contract End Date"';
export const DATE_AFTER_CONTRACT_END_PLUS_1 = 'Cannot be later than the day after the "Contract End Date"';

export const DATE_AFTER_PONUMBER_START = 'PO Number End Date can\'t be less than PO Number Start Date';

export const MUST_BE_GREATER_THAN_ZERO = 'Must be greater than 0';

export const MUST_NOT_BE_ZERO_WHEN_ROUNDED = 'Must not be zero when rounded';
export const MAX_4_DECIMAL_LENGTH_YUP_TEMPLATE = 'Must have a maximum of 4 decimal places';

export const DATE_TYPE_ERROR = 'Please enter a valid date - dd/mm/yyyy';
export const DATE_IN_THE_PAST = 'Date cannot be in the past';
